module.exports = __webpack_public_path__ + "static/media/Barack H. Obama - 2008.ed17cae1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Barack H. Obama - 2008.jpg
// module id = 441
// module chunks = 0